import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useHelpContentDocumentDetails } from "./Flightinfo.hooks";

export const AddEditFlightinfo = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editPageContent,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useHelpContentDocumentDetails(query.get("editId") || "");

  const {
    data: editPageContentById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  const [currentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
      english_title: editPageContentById
        ? decodeHTML(editPageContentById.payload?.english_title)
        : editPageContent
          ? decodeHTML(editPageContent?.english_title)
          : "",

      malay_title: editPageContentById
        ? decodeHTML(editPageContentById.payload?.malay_title)
        : editPageContent
          ? decodeHTML(editPageContent?.malay_title)
          : "",

      mandarin_title: editPageContentById
        ? decodeHTML(editPageContentById.payload?.mandarin_title)
        : editPageContent
          ? decodeHTML(editPageContent?.mandarin_title)
          : "",

      description_english: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_english)
        : editPageContent
          ? decodeHTML(editPageContent?.description_english)
          : "",

      description_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.description_malay)
          : "",

      description_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.description_mandarin)
          : "",

      redirect_url_english: editPageContentById
        ? decodeHTML(editPageContentById.payload?.redirect_url_english)
        : editPageContent
          ? decodeHTML(editPageContent?.redirect_url_english)
          : "",

      redirect_url_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.redirect_url_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.redirect_url_malay)
          : "",

      redirect_url_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.redirect_url_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.redirect_url_mandarin)
          : "",

      image: editPageContentById?.payload?.image
        ? [
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: editPageContentById?.payload?.image,
            },
          ]
        : editPageContent?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: editPageContent?.image,
              },
            ]
          : [],

      // published: editPageContentById
      //   ? editPageContentById.payload?.published
      //   : editPageContent
      //     ? editPageContent?.published
      //     : false,
    },

    fields: fields.pageContents,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (Array.isArray(field) && field.length > 0) {
          const fileItem = field[0];

          if (fileItem.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", fileItem.originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);

            if (res?.response?.data) {
              data[key] = res.response.data;
            } else {
              data[key] = "";
            }
          } else if (fileItem.url) {
            data[key] = fileItem.url;
          } else {
            data[key] = "";
          }
        } else {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action,
      method,
      module: "Flight Information",
      subModule: "pageContents",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageContent?.id || editPageContentById?.payload?.id,
          airport: currentAirport,
          published: true,
        }),
        ...data,
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Flight Information`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/flight-information-card/${editPageContent?.id || editPageContentById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Flight Information"
      />
    </ContentWrapper>
  );
};
